import React from 'react';
import PropTypes from 'prop-types';

/**
 * A toolbar action for the the gallery which wraps a component and adds properties that the gallery uses
 */
export default class GalleryToolbarAction extends React.Component {
  render() {
    return this.props.children;
  }
}

GalleryToolbarAction.propTypes = {
  /**
   * A function which returns whether the toolbar can be used
   */
  isAvailable: PropTypes.func,
  /**
   * The child component of the toolbar action to render
   */
  children: PropTypes.node
};
